export function isBrowser() {
	return typeof window !== "undefined";
}

export function decodeValue(value: string) {
	if (isBrowser()) {
		return atob(value);
	}

	return Buffer.from(value, "base64").toString("ascii");
}

export function encodeValue(value: string) {
	if (isBrowser()) {
		return btoa(value);
	}

	return Buffer.from(value, "ascii").toString("base64");
}
